import { useState } from 'react';
import styles from './AppLock.module.css';

export function SetupScreen({
  onSubmit,
  onSkip,
}: {
  onSubmit: (password: string) => Promise<void>;
  onSkip: () => void;
}) {
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    if (password.length < 6) {
      setError('Password must be at least 6 characters.');
      return;
    }
    if (password !== confirm) {
      setError('Passwords do not match.');
      return;
    }
    setLoading(true);
    try {
      await onSubmit(password);
    } catch {
      setError('Setup failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.screen}>
      <form onSubmit={handleSubmit} className={styles.card}>
        <h1 className={styles.title}>Set Password</h1>
        <p className={styles.subtitle}>
          This password will encrypt your allergen data. There is no recovery if you forget it.
        </p>

        {error && <div className={styles.error}>{error}</div>}

        <div className={styles.field}>
          <label htmlFor="setup-password" className={styles.label}>
            Password
          </label>
          <input
            id="setup-password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoFocus
            minLength={6}
            required
            className={styles.input}
          />
        </div>

        <div className={styles.fieldLg}>
          <label htmlFor="setup-confirm" className={styles.label}>
            Confirm Password
          </label>
          <input
            id="setup-confirm"
            type="password"
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            required
            className={styles.input}
          />
        </div>

        <button
          type="submit"
          disabled={loading || !password || !confirm}
          className={styles.primaryButton}
        >
          {loading ? 'Setting up…' : 'Create Password'}
        </button>

        <button
          type="button"
          onClick={onSkip}
          className={styles.secondaryButton}
        >
          Skip
        </button>
      </form>
    </div>
  );
}
